export default __webpack_public_path__ + "static/media/icon-arrow-left.320df0c8.svg";